export class Customer {
    fullyQualifiedName: string;
    displayName: string;
    id: string;
}
